import type { TRuleWithTheme } from '@/styles/theme';

export const heroImage: TRuleWithTheme = () => ({
    height: '8rem',
    objectFit: 'contain',
    paddingBottom: '0.5rem',
});

export const buttonsContainer: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    columnGap: '1.25rem',
    rowGap: '0.5rem',

    paddingTop: '0.5rem',

    min768: {
        flexDirection: 'row',
    },
});

export const featuresList: TRuleWithTheme = () => ({
    display: 'contents',
});

export const featuresListItem: TRuleWithTheme = () => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
});
